import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Box, Typography } from "@mui/material";
import { TAG_COLOR_MAP } from "../utils/constants";
export const TagBadge = React.memo(({ tag, label }) => {
    const displayText = label || tag || "No Tag";
    if (!tag) {
        return (_jsx(Typography, { className: "all-Font-Sizes", sx: { color: "#a1a1aa", fontStyle: "italic", whiteSpace: "nowrap" }, children: displayText }));
    }
    const s = TAG_COLOR_MAP[tag] || { bg: "#f4f4f5", color: "#52525b" };
    return (_jsx(Box, { className: "all-Font-Sizes", sx: { display: "inline-flex", alignItems: "center", bgcolor: s.bg, color: s.color, borderRadius: "16px", px: 1.2, py: 0.3, fontWeight: 600, whiteSpace: "nowrap" }, children: displayText }));
});
